import { type Token as TokenType } from "marked";
import { Token } from "./token";
import { FC } from "react";
import { RendererProps } from "./renderers";

interface IProps {
  tokens: TokenType[];
  renderers: { [key: string]: FC<RendererProps> };
}

export function Tokens({ tokens, renderers }: IProps) {
  return tokens.map(token => <Token token={token} renderers={renderers} />);
}
